function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.75 0.75C12.6906 0.75 12.6297 0.760938 12.5687 0.785938L3.5625 4.40469H1C0.8625 4.40469 0.75 4.52031 0.75 4.66406V9.33594C0.75 9.47969 0.8625 9.59531 1 9.59531H2.5875C2.52969 9.77656 2.5 9.96875 2.5 10.1641C2.5 11.1937 3.34062 12.0312 4.375 12.0312C5.24062 12.0312 5.97031 11.4437 6.18594 10.65L12.5703 13.2156C12.6312 13.2391 12.6922 13.2516 12.7516 13.2516C13.0156 13.2516 13.2516 13.0297 13.2516 12.7328V1.26875C13.25 0.971875 13.0156 0.75 12.75 0.75ZM4.375 10.9109C3.96094 10.9109 3.625 10.5766 3.625 10.1641C3.625 9.98906 3.68594 9.82187 3.79687 9.68906L5.12344 10.2219C5.09219 10.6062 4.76875 10.9109 4.375 10.9109Z",
  fill: "#27A18A"
});

var SvgAnnouncementIcon = function SvgAnnouncementIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAnnouncementIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/announcement_icon.bbb858b2.svg";
export { ForwardRef as ReactComponent };